import styled from '@emotion/styled';
import moment from 'moment-timezone';
import React, { FC, useState } from 'react';
import { useParams } from 'react-router';
import {
  MonitoringDateRange,
  calculateStep,
  calculateUnit,
  getDefaultMonitoringDateRange,
} from '../../monitoring/DateRange-Dropdown-util';

import { CustomGraph } from '../../../feature/feature-views/graph-types';
import { FEATURE_VIEW_MONITORING_SUMMARY_GRAPH } from '../../../feature/graph-configuration';
import MonitoringGraphs from './MonitoringGraphs';

import FeatureViewFailingIds from './FeatureViewFailingIds';
import FeatureViewHealthDrillDowns from './FeatureViewHealthDrillDowns';
import NumberOfFeatureViewsAndTablesMaterialized from './NumberOfFeatureViewsAndTablesMaterialized';
import NumberOfFeatureViewsAndTablesTotal from './NumberOfFeatureViewsAndTablesTotal';

import { Card, FlexGroup } from '@lithos';
import { TimeSelector } from '@tecton';

const FeatureViewMonitoring: FC = () => {
  const { workspace } = useParams();
  const defaultMonitoringDateRange: MonitoringDateRange = getDefaultMonitoringDateRange();

  const [monitoringDateRange, setMonitoringDateRange] = useState<MonitoringDateRange>(defaultMonitoringDateRange);

  const FeatureViewTableWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  `;

  const customGraphs: Record<string, React.ReactNode> = {
    [CustomGraph.NUMBER_OF_FEATURE_VIEWS_AND_TABLE]: (
      <>
        <Card title="# of Feature Views and Table">
          <FeatureViewTableWrapper>
            <Card title="Total">
              <NumberOfFeatureViewsAndTablesTotal monitoringDateRange={monitoringDateRange} />
            </Card>
            <Card title="Materialized">
              <NumberOfFeatureViewsAndTablesMaterialized monitoringDateRange={monitoringDateRange} />
            </Card>
          </FeatureViewTableWrapper>
        </Card>
      </>
    ),
    [CustomGraph.FEATURE_VIEW_DRILL_DOWN]: (
      <>
        <FeatureViewHealthDrillDowns monitoringDateRange={monitoringDateRange} />

        <FeatureViewFailingIds monitoringDateRange={monitoringDateRange} />
      </>
    ),
  };

  return (
    <FlexGroup gapSize="4" padding="0" direction="column">
      <TimeSelector
        onSelection={(start, end) => {
          const step = calculateStep(moment(start), moment(end));
          const unit = calculateUnit(moment(start), moment(end));
          setMonitoringDateRange({
            startTime: () => start.valueOf(),
            endTime: () => end.valueOf(),
            requestId: `${start.valueOf()}${end.valueOf()}`,
            step,
            unit,
          });
        }}
      />

      <MonitoringGraphs
        monitoringDateRange={monitoringDateRange}
        graphsData={FEATURE_VIEW_MONITORING_SUMMARY_GRAPH}
        customGraphRecord={customGraphs}
        workspace={workspace ?? ''}
      />
    </FlexGroup>
  );
};

export default FeatureViewMonitoring;
